import { TableCell, TableRow, Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const TableCellHeader = styled(TableCell)(({ theme }) => ({
  color: theme.palette.secondary.main,
  font: '500 21px Montserrat',
  backgroundColor: '#F1F5FA',
  verticalAlign: 'middle',
  '& span': {
    verticalAlign: 'bottom',
    paddingLeft: '4px',
  },
  [theme.breakpoints.down('xl')]: {
    fontSize: '16px',
    '& span': {
      fontSize: '18px',
    },
  },
}));

export const StyledCell = styled(TableCell)(({ theme }) => ({
  color: '#707070',
  [theme.breakpoints.up('xl')]: {
    padding: '20px',
    fontSize: '16px',
  },
}));

export const RoleContainer = styled(Box)(() => ({
  display: 'flex',
  gap: 1,
  flexWrap: 'wrap',
  justifyContent: 'center',
}));

export const RoleBox = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.light, 0.5),
  padding: '2px 8px',
  borderRadius: '16px',
}));

export const Row = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.grey, 0.2),
  },
}));
